import Duck from 'extensible-duck';
import get from 'lodash/get';
import set from 'lodash/set';

// import produce from 'appDir/lib/functions/produce';
import produce from 'immer';
import jsonApiDuck from './jsonApiDuck';

export default new Duck({
  namespace: 'app',
  store: 'app',
  types: ['INITIALIZE_STATE', 'SET'],
  initialState: {
    railsContext: {},
  },
  reducer: produce(
    (draft, { type, payload, meta }, { types, initialState }) => {
      switch (type) {
        case types.INITIALIZE_STATE:
          return initialState;
        case types.SET:
          set(draft, [payload.namespace, payload.key], payload.value);
          return;
        case 'all/railsContext/UPDATE_IS_PREVIEWING_WEBSITE_FULFILLED':
          draft.railsContext.isPreviewingWebsite =
            payload.data.is_previewing_website;
          return;
      }
    }
  ),
  selectors: {
    canEditOrganization: new Duck.Selector(selectors => store => {
      const currentUser = selectors.currentUser(store);
      const currentUserRole = get(currentUser, ['attributes', 'role']);
      switch (currentUserRole) {
        case 'admin':
          return true;
        case 'organizer': {
          const currentUserOrganizationId =
            currentUser.attributes.organizationId;
          const currentOrganizationId = get(
            jsonApiDuck.selectors.getResource(store, 'CURRENT_ORGANIZATION'),
            ['id']
          );
          return currentUserOrganizationId == currentOrganizationId;
        }
        default:
          return false;
      }
    }),
    get: (store, namespace, key) => get(store.appStore, [namespace, key]),
    currentOrganization: store =>
      jsonApiDuck.selectors.getResource(store, 'CURRENT_ORGANIZATION'),
    currentUser: store =>
      jsonApiDuck.selectors.getResource(store, 'CURRENT_USER'),
    isEditingOrganization: new Duck.Selector(selectors => store =>
      selectors.canEditOrganization(store) &&
      !selectors.isPreviewingWebsite(store)
    ),
    isPreviewingWebsite: store =>
      store.appStore.railsContext.isPreviewingWebsite,
  },
  creators: ({ types }) => ({
    initializeState: () => ({ type: types.INITIALIZE_STATE }),
    set: (namespace, key, value) => ({
      type: types.SET,
      payload: { namespace, key, value },
    }),
  }),
});
